import React from 'react';
import { t } from '../../services/sessionManager';
import { Language } from '../../types';

interface LoaderProps {
  language?: Language;
  text?: string;
  fullScreen?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ language, text, fullScreen = false }) => {
  const content = (
    <div className="flex flex-col items-center justify-center">
      <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      {language && <p className="mt-4 text-gray-500">{text || t('loading', language)}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center">
        {content}
      </div>
    );
  }

  return content;
};